import { host } from '@/services/HostAPI'

let roleList = []

const now = () => new Date().getTime()
const roleListStaleAfterMilliseconds = 1000 * 60 * 5 // 5 minutes

// This is to ensure that the first call to loadRolesForUser() will always be executed
let whenRoleListLoaded = now() - roleListStaleAfterMilliseconds - 1

const roleName = {
  OnlinePaymentsEnabled: 'Online Payments Enabled',
  PostOnlinePayments: 'Post Online Payments',
  ShowOnCalendar: 'Show on Calendar',
  SendSmsTexts: 'Send Sms Texts'
}

const isInRole = async roleName => {
  console.log({ loc: 'isInRole', roleName, roleList })
  return roleList.includes(roleName)
}

const isPermissionsCacheStale = () => {
  let thisTime = now()
  let isStale = thisTime - whenRoleListLoaded > roleListStaleAfterMilliseconds
  return isStale
}

const loadRolesForUser = async () => {
  console.log({ loc: 'loadRolesForUser' })
  if (!isPermissionsCacheStale()) {
    console.log({ loc: 'loadRolesForUser', status: 'cache hit' })
    return
  }

  const rs = await host.user.grantedRoles({})
  roleList = rs.InfoList
  whenRoleListLoaded = now()
}

export { isInRole, roleName, loadRolesForUser }
